/* =========================================================================
   COOKEHOUSE: ch-site-usp.js
   Phase 2 extraction (Aug 2026) of the inline <script> previously embedded
   in sections/site-usp.liquid.

   Changes from the inline original:
   - Multi-instance: initialises every `.ch-site-usp` section root instead
     of hardcoding one section.id, since the section can render in the
     header group AND on product templates simultaneously.
   - Idempotent: roots are marked with data-ch-usp-init so double script
     tags (two section instances) or editor reloads cannot double-bind.
   - Theme editor support: re-initialises on shopify:section:load.
   - Logic is otherwise identical to the original.
   ========================================================================= */
(function () {
  'use strict';

  function initSiteUsp(root) {
    if (root.dataset.chUspInit === 'true') return;
    root.dataset.chUspInit = 'true';

    /* ---------- Mobile slider ---------- */
    var mobileSlides = root.querySelectorAll('.usp-slide');
    var mobilePrev = root.querySelector('.usp-mobile-wrapper .usp-slider-arrow.prev');
    var mobileNext = root.querySelector('.usp-mobile-wrapper .usp-slider-arrow.next');
    var mobileCurrentIndex = 0;

    function showMobileSlide(index) {
      mobileSlides.forEach(function (slide) { slide.classList.remove('active'); });
      if (mobileSlides[index]) {
        mobileSlides[index].classList.add('active');
        mobileCurrentIndex = index;
      }
    }
    function nextMobileSlide() { showMobileSlide((mobileCurrentIndex + 1) % mobileSlides.length); }
    function prevMobileSlide() { showMobileSlide((mobileCurrentIndex - 1 + mobileSlides.length) % mobileSlides.length); }

    if (mobileNext && mobilePrev) {
      mobileNext.addEventListener('click', nextMobileSlide);
      mobilePrev.addEventListener('click', prevMobileSlide);
    }

    /* ---------- Mobile touch/swipe ---------- */
    var mobileSlider = root.querySelector('.usp-mobile-slider');
    if (mobileSlider) {
      var touchStartX = 0, touchEndX = 0;
      mobileSlider.addEventListener('touchstart', function (e) { touchStartX = e.changedTouches[0].screenX; }, { passive: true });
      mobileSlider.addEventListener('touchend', function (e) {
        touchEndX = e.changedTouches[0].screenX;
        var t = 50;
        if (touchEndX < touchStartX - t) nextMobileSlide();
        if (touchEndX > touchStartX + t) prevMobileSlide();
      }, { passive: true });
    }

    /* ---------- Desktop carousel ---------- */
    var desktopContainer = root.querySelector('.usp-desktop-slider-container');
    var desktopTrack = root.querySelector('.usp-desktop-track');
    var desktopItems = root.querySelectorAll('.usp-desktop-item');
    var desktopPrev = root.querySelector('.usp-desktop-slider-arrow.prev');
    var desktopNext = root.querySelector('.usp-desktop-slider-arrow.next');

    if (desktopContainer && desktopTrack && desktopPrev && desktopNext) {
      var totalBlocks = parseInt(desktopContainer.dataset.totalBlocks, 10);
      var columns = parseInt(desktopContainer.dataset.columns, 10);

      if (totalBlocks > columns) {
        var currentIndex = 0;
        var maxIndex = totalBlocks - columns;

        var updateDividerVisibility = function () {
          desktopItems.forEach(function (item) { item.classList.remove('hide-divider'); });
          var lastVisibleIndex = currentIndex + columns - 1;
          desktopItems.forEach(function (item) {
            if (parseInt(item.dataset.itemIndex, 10) === lastVisibleIndex) item.classList.add('hide-divider');
          });
        };

        var updateDesktopCarousel = function () {
          if (desktopItems.length === 0) return;
          var itemWidth = desktopItems[0].offsetWidth;
          var gap = parseFloat(getComputedStyle(desktopTrack).gap) || 40;
          desktopTrack.style.transform = 'translateX(' + (-(currentIndex * (itemWidth + gap))) + 'px)';

          if (currentIndex <= 0) { desktopPrev.style.opacity = '0.3'; desktopPrev.style.pointerEvents = 'none'; }
          else { desktopPrev.style.opacity = '1'; desktopPrev.style.pointerEvents = 'auto'; }
          if (currentIndex >= maxIndex) { desktopNext.style.opacity = '0.3'; desktopNext.style.pointerEvents = 'none'; }
          else { desktopNext.style.opacity = '1'; desktopNext.style.pointerEvents = 'auto'; }
          updateDividerVisibility();
        };

        desktopPrev.addEventListener('click', function () { if (currentIndex > 0) { currentIndex--; updateDesktopCarousel(); } });
        desktopNext.addEventListener('click', function () { if (currentIndex < maxIndex) { currentIndex++; updateDesktopCarousel(); } });

        updateDesktopCarousel();
        window.addEventListener('resize', updateDesktopCarousel);
      } else if (desktopItems.length > 0) {
        desktopItems[desktopItems.length - 1].classList.add('hide-divider');
      }
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.ch-site-usp').forEach(initSiteUsp);
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
